import { render } from "./SurpriseGiftPurchase.vue?vue&type=template&id=3b623791&scoped=true"
import script from "./SurpriseGiftPurchase.vue?vue&type=script&lang=js"
export * from "./SurpriseGiftPurchase.vue?vue&type=script&lang=js"

import "./SurpriseGiftPurchase.vue?vue&type=style&index=0&id=3b623791&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b623791"]])

export default __exports__